import React, { Component } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { CierreMensualProduccionForm } from "./components/CierreMensualProduccionForm";
import "../../styles/CierresMensuales.css";
import "../../styles/ComparativoMensualProduccion.css";
// los totales de los cierres de almacén se reutilizan tal cual, con los
// estilos de su propio módulo
import "../../../../InventariosAlmacen/components/Existencia/styles/Existencia.css";

class RegistroCierreMensualProduccion extends Component {
    regresar = () => {
        this.props.history.goBack();
    };

    render() {
        return (
            <div
                className="mb-4 col-12"
                style={{ maxWidth: "91.5vw", margin: "auto" }}
            >
                <CardForm
                    icon="produccion_activo"
                    titulo="Registrar cierre mensual de producción"
                    subtitulo=""
                    col="12"
                >
                    <CierreMensualProduccionForm regresar={this.regresar} />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(RegistroCierreMensualProduccion);
